<template>
    <div v-if="isActive">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'ExpertPanelTab',
    props: {
        title: String,
    },
    inject: ['state', 'updateTabs'],
    data() {
        return {
            index: null,
            isActive: false,
        };
    },
    watch: {
        state: {
            handler() {
                this.isActive = this.index === this.state.currentTab;
            },
            deep: true,
        },
        title() {
            this.state.tabs[this.index] = {
                name: this.title,
            };
            this.updateTabs(this.state.tabs);
        },
    },
    beforeMount() {
        this.index = this.state.count++;
        this.state.tabs[this.index] = {name: this.title};
        this.isActive = this.index === this.state.currentTab;
        this.updateTabs(this.state.tabs);
    },
};
</script>

<style scoped>

</style>